import { StackProps, Text } from "@chakra-ui/layout";
import { Switch, SwitchProps } from "@chakra-ui/switch";
import React from "react";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";

interface SwitchFieldProps extends BaseFieldProps {}

export const SwitchField = ({
  name,
  label,
  id,
  helperText,
  infoText,
  horizontal,
  labelProps,
  valueProps,
  hideField,
  fcProps,
  ...switchProps
}: SwitchFieldProps & SwitchProps) => {
  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      infoText={infoText}
      horizontal={horizontal}
      labelProps={labelProps}
      valueProps={valueProps}
      hideField={hideField}
      fcProps={fcProps}
    >
      {({ field }) => (
        <Switch
          {...field}
          colorScheme="green"
          {...switchProps}
          isChecked={field.value}
        />
      )}
    </FieldWrapper>
  );
};
